import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales robots – are your sales people 'coin operated'?" />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/&amp;title=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;summary=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-piper.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Sales robots – are your sales people &#39;coin operated&#39;?</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>17 May 2016</li>
                        <li>3 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Are you wondering why your sales conversion rates are low? and why you staff attrition rate is high? Perhaps it’s because your sales model is stuck in the 1980’s. Perhaps it&#39;s because you are treating your sales people like robots?</h3>

<div className="rich-text"><p>Much to my astonishment, there are still a lot of vendors that believe the old and unspeakably stupid maxim that sales people are <em>coin operated</em> <em>– ‘drop a coin in their back and off they will go like a robot’</em>. I’m sure that this old viewpoint is gradually waning (and not before time), but I still hear this non-sense from some ignorant business leaders</p><p>The truth is that sales people are the polar opposite of a robots. Every sales person learns very early on about the importance of the soft (qualitative) people skills and being able to adjust their behaviour, style and approach to diverse customer types. Yes, sales people are generally motivated by an opportunity to earn a commission from their successes, but more and more research today reveals that financial remuneration is nearly always a secondary motivating factor. Not to dwell on motivation (mostly because it’s a complex subject in itself), but according to Daniel Pink and his book - <em>Drive - </em>there are three elements of the motivation formula: <strong><em>autonomy, mastery, and purpose,</em></strong> and sales people are just the same as all other employees when it comes to this stuff.</p><p>So why do so many businesses make a conscious decision to isolate their sales people from standard business practices that all other departments and functions are exposed to? I have now lost track of the number of businesses that I have worked with where sales people are deliberately kept away from almost all aspects of the quantitative measures such as the P&amp;L, balance sheet and financial ratios – <em>“you don’t need to worry about finance and accounting….you just concentrate on selling Mr (or Miss) Robot”.</em></p><p>Ironically, sales people the world over are constantly reminded about the importance of 'accurate forecasting', and yet there is little to be gained by simply barking at the sale people about how <em>“forecasting is important”</em> if you don’t explain why, and then give them the tools by which to ensure this accuracy. Sales people should be educated about all of the specific business fundamentals and key financial metrics that drive business planning, performance and sustainability. Some of these fundamentals are as follows:</p><ul><li>Cost of Sales</li><li>Cost Per Employee</li><li>Revenue Per Employee</li><li>Contribution Margin (per product/unit)</li><li>Expense to Revenue Ratio</li><li>Profit Per Employee</li><li>Average Order Value</li><li>Average Cost Per Sale</li><li>Sales Cycle Time</li><li>Cost-Volume Ratios, and Break-Even Analysis</li><li>EBIT</li></ul></div>
<img alt="Measurements" className="img-responsive" height="431" src="../../../media/images/AAEAAQAAAAAAAAfdAAAAJDc2MmFiOTFjLTdhZWYtNDE0Yy.width-647.jpg" width="647"/>

<div className="rich-text"><p>The above list is just some of the key financial and accounting measurements that should be shared with the sales department in this modern era of business, and yet many businesses still prefer to ‘shield’ their sales team from these important business metrics in order to allow them to simply 'focus on selling'. This is narrow and outdate thinking, and I can prove it.</p><p>As an experiment a few years ago, I began sharing some of these key financial metrics (with a focus on the cost side) with my teams in order to help the sales people better understand concepts that can have a big impact on profitability, and sustainability. Two areas of focus (and education) was <em>Cost Volume Analysis</em> and <em>Activity Based Costing </em>or in simple terms - <em>total</em> <strong><em>cost of sales</em></strong>. Admittedly, some of the sales people found some of this stuff a little boring, but for the vast majority this understanding helped to highlight what an hour of each sales person’s time was actually costing our business and for some this was a light bulb moment. Most of my team had never previously been exposed to this type of financial data and sharing it proved to be a master stroke if I do say so myself. Not only did the team have a new appreciation and focus on measuring and managing our cost base, but they also gained a clearer understanding of how (and why) our finance team run the business <em>– monthly, quarterly and yearly – </em>along with the various budgeting cycles and external business drivers. All of these metrics also help to bring into sharp focus the downside of the often forgotten <strong>‘opportunity costs’</strong> associated with allocating company resource to the wrong (<em>column fodder</em>) opportunities. As we all know, focusing resource on the wrong sales opportunities is the quickest way to grow the business of your competitors.</p><p>So, stop treating your sales people like robots and begin to educate them about why certain business measures and management practices are important to your business. An inclusive and <i>participative </i>working environment is always the best way to establish engagement and genuine 'buy in'…..regardless of role, duty or function. Pleasingly, you will also find (as I did) that the ancillary benefit of this more open and transparent approach with your sales people is that you will also be laying the foundation for <em>autonomy, mastery and purpose</em>. </p><p>Result? Increased conversion rates and decreased attrition….mark my words.</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/&amp;title=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;summary=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20robots%20%E2%80%93%20are%20your%20sales%20people%20%27coin%20operated%27%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-robots-are-your-sales-people-coin-operated/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 